import * as React from "react";

import { Box, List, ListItem } from "@mui/material";
import { ListNavItem } from "./ListNavItem";

type listItemType = {
  title: string;
  icon: JSX.Element;
  path?: string;
  badgeCount?: number;
  children?: listItemType[];
};

type MenuListProps = {
  onClickEvent?: () => void;
  listItems: listItemType[];
};

export const MenuList: React.FC<MenuListProps> = ({
  onClickEvent,
  listItems,
}) => {
  return (
    <List>
      {listItems.map((entry) => (
        <Box key={entry.title}>
          <ListItem disablePadding>
            <ListNavItem listItem={entry} onClick={onClickEvent} />
          </ListItem>
          {entry.children?.map((childEntry) => (
            <ListItem
              key={`child_${childEntry.title}`}
              disablePadding
              sx={{ paddingLeft: 2 }}
            >
              <ListNavItem listItem={childEntry} onClick={onClickEvent} />
            </ListItem>
          ))}
        </Box>
      ))}
    </List>
  );
};
